<div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="center center">

    <a mat-button color="primary" (click)="navigateToHelp()">Ayuda</a>
    <a mat-button color=primary (click)="navigateToTermsAndConditions()">Términos y condiciones</a>

</div>